import {
  Input,
  OnInit,
  Component,
  OnDestroy,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { HelpService } from '../core/help.service';

import { DimensionValue } from '../core/help.models';

// * Panel trigger component - just the Icon button
// * Portal service creates actual panel content at document.body
@Component({
  selector: 'app-help-panel',
  standalone: false,
  templateUrl: './help-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './help-panel.component.scss',
})
export class HelpPanelComponent implements OnInit, OnDestroy {
  faInfoCircle = faInfoCircle;

  @Input() helpKey!: string;

  // * Anchor ID (1. set by directive, or 2. generated in Declarative Mode)
  @Input() anchorId?: string;

  @Input() title?: string;
  @Input() width?: DimensionValue;
  @Input() height?: DimensionValue;
  @Input() minWidth?: DimensionValue;
  @Input() minHeight?: DimensionValue;
  @Input() maxWidth?: DimensionValue;
  @Input() maxHeight?: DimensionValue;

  constructor(
    private elementRef: ElementRef,
    private helpService: HelpService,
  ) {}

  private isDeclarative = false;

  ngOnInit(): void {
    if (!this.helpKey) {
      console.warn('HelpPanelComponent: helpKey is required');
      return;
    }

    // * if no anchorId provided, we're in Declarative Mode - register self
    if (!this.anchorId) {
      this.isDeclarative = true;
      this.anchorId = this.helpService.registerAnchor(this.elementRef, {
        key: this.helpKey,
        mode: 'panel',
        title: this.title,
        width: this.width,
        height: this.height,
        minWidth: this.minWidth,
        minHeight: this.minHeight,
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight,
      });
    }
  }

  ngOnDestroy(): void {
    // * only unregister if we registered it (Declarative Mode)
    if (this.isDeclarative && this.anchorId) {
      this.helpService.unregisterAnchor(this.anchorId);
    }
  }

  openPanel(): void {
    if (this.anchorId) {
      this.helpService.openPanel(this.anchorId);
    }
  }
}
